<template>
  <a-form class="margin-bottom" :form="form">
    <a-row :gutter="12">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
        <a-form-item label="Type Tax">
          <a-select
            showSearch
            allowClear
            placeholder="Choose Type Tax"
            @change="handleType"
            v-decorator="[
              'type_ppn',
              { rules: [{ required: true }], },
            ]"
          >
            <a-select-option key="ppn_dibebaskan" value="ppn_dibebaskan" >PPN Dibebaskan</a-select-option>
            <a-select-option key="ppn_sktd" value="ppn_sktd" >PPN SKTD</a-select-option>
            <a-select-option key="ppn_dipungut" value="ppn_dipungut" >PPN Dipungut</a-select-option>
            <a-select-option key="ppn_memungut" value="ppn_memungut" >PPN Memungut</a-select-option>
            <a-select-option key="ppn_migas" value="ppn_migas" >PPN Migas</a-select-option>
            <a-select-option key="ppn_ekspor" value="ppn_ekspor" >PPN Ekspor</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="vis_value_tax" label="Value tax">
          <a-input-number
            v-decorator="[
              'value_tax',
              {
                rules: [{ required: true }],
                initialValue: datasource.value_tax,
              },
            ]"
            :formatter="
              (value) =>
                `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(curReplace, '')"
            :min="0"
            class="m-width-full m-text-align right"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="Upload Tax Document" v-if="vis_upload_tax">
            <a-upload
              :showUploadList="true"
              :file-list="push"
              :remove="handleRemove"
              :beforeUpload="beforeUpload"
              v-decorator="[
                'upload_document_tax',
                { rules: [{ required: true, validator: validateStatusUpload }], valuePropName: 'push' },
              ]"
            >
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
          </a-form-item>
        <!-- <a-form-item label="PPN SKTD">
          <a-input-number
            v-decorator="[
              'ppn_sktd',
              {
                rules: [{ required: false }],
                initialValue: datasource.ppn_sktd,
              },
            ]"
            :formatter="
              (value) =>
                `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(curReplace, '')"
            :min="0"
            class="m-width-full m-text-align right"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="PPN Dipungut">
          <a-input-number
            v-decorator="[
              'ppn_dipungut',
              {
                rules: [{ required: false }],
                initialValue: datasource.ppn_dipungut,
              },
            ]"
            :formatter="
              (value) =>
                `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(curReplace, '')"
            :min="0"
            class="m-width-full m-text-align right"
          ></a-input-number>
        </a-form-item> -->
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
        <!-- <a-form-item label="PPN Memungut">
          <a-input-number
            v-decorator="[
              'ppn_memungut',
              {
                rules: [{ required: false }],
                initialValue: datasource.ppn_memungut,
              },
            ]"
            :formatter="
              (value) =>
                `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(curReplace, '')"
            :min="0"
            class="m-width-full m-text-align right"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="PPN Migas">
          <a-input-number
            v-decorator="[
              'ppn_migas',
              {
                rules: [{ required: false }],
                initialValue: datasource.ppn_migas,
              },
            ]"
            :formatter="
              (value) =>
                `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(curReplace, '')"
            :min="0"
            class="m-width-full m-text-align right"
          ></a-input-number>
        </a-form-item> -->
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "detailInvoice",
  props: {
    detil_invoice: {},
    information: {},
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      postData: new FormData(),
      currency: "IDR",
      datasource: {
        // ppn_sktd: 0,
        // ppn_dipungut: 0,
        // ppn_memungut: 0,
        // ppn_migas: 0,
        value_tax: 0,
      },
      vis_value_tax: false,
      vis_upload_tax:false,
      push:[],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate", "getDefaultDateFormat"]),
    curReplace() {
      return eval(
        "/\\" + this.symbolCurrencyES6(this.currency, 1) + "\\s?|(,*)/g"
      );
    },
    initCUr() {
      return this.symbolCurrencyES6(this.currency, 0);
    },
  },
  mounted() {
    if (this.datasource[0].type_ppn == 'ppn_ekspor') {
      this.vis_value_tax = false;
    } else {
      this.vis_value_tax = true;
    }
    if (this.datasource[0].upload_document_tax && this.datasource[0].upload_document_tax != 'No File Uploaded')
      this.convertfiles(this.datasource[0].upload_document_tax, this.datasource[0].path_upload_document_tax, this.datasource[0].tax_files)

    if (this.datasource[0].type_ppn == 'null') {
      this.vis_value_tax = false;
      this.vis_upload_tax = false;
    } else {
      this.vis_upload_tax = true;
    }
  },
  created() {
    this.currency = this.information ? this.information.currency : "IDR";
  },
  methods: {
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        values.push = this.push[0];
        Event.$emit("emitChild", {
          detil_invoice: values,
        });
      });
    },
    validateStatusUpload(rule, value, callback) {
      if (this.push.length > 0) {
        callback();
        return;
      }
      callback("File upload can't be empty!");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.push = [file];
        //this.form.resetFields();
        return false;
      }
    },
    handleRemove() {
      this.push = [];
    },
    handleType(val){
      this.datasource.value_tax=0;
      if(val=='ppn_ekspor' || val == 'null'){
        this.vis_value_tax = false;
        this.push = [];
      }else{
        this.vis_value_tax = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
            value_tax: null,
          });
        });
        this.push = [];
      }

      if (val == 'null') {
        this.vis_upload_tax = false;
      } else {
        this.vis_upload_tax = true;
      }
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style></style>
